import table from './table';

export const hlr = {
  namespaced: true,
  modules: {
    table
  }
};
